export default __webpack_public_path__ + "static/media/BCA16.d561b54b.jpg";